import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const ShoppingBag32: FC<IconV2Props> = ({ icon, chroma, className }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight32 : s.svgDark32,
      `svg-icon--${icon}`,
      className
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    data-icon={getDataIconAttribute(chroma, icon, '32')}
  >
    <path
      fill="#000"
      fillRule="evenodd"
      d="M15.855 3.52c2.831 0 4.564 2.077 5.295 5.466L28 9v16H4V8.95l6.565.014c.734-3.376 2.465-5.444 5.29-5.444ZM5.5 10.453V23.5h21V10.497l-5.101-.01c.104.866.156 1.797.156 2.783h-1.5c0-1.01-.057-1.941-.17-2.788l-8.059-.016c-.113.85-.171 1.788-.171 2.804h-1.5c0-.995.053-1.934.16-2.807l-4.815-.01ZM15.855 5.02c-1.855 0-3.122 1.436-3.748 3.947l7.5.016c-.625-2.52-1.894-3.963-3.752-3.963Z"
    />
  </svg>
);

export default ShoppingBag32;
